import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

@Module({ namespaced: true, name: 'SuporteFeedbackStore' })
export default class SuporteFeedbackStore extends VuexModule {
  public perguntas: any[] = []

  public respostas: any = null

  @Mutation
  setPerguntas(value: any[]) {
    this.perguntas = value
  }

  @Mutation
  setRespostas(value: any) {
    this.respostas = value
  }

  @Mutation
  clearRespostas() {
    this.respostas = null
  }

  @Action
  async fetchPerguntas() {
    try {
      const request = await Apis.FeedbackAPI.FeedbackAPI.getAllPerguntaDoFeedback()
      if (request.success) {
        this.setPerguntas(request.data || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertPergunta(payload: any) {
    try {
      return await Apis.FeedbackAPI.FeedbackAPI.upsertPerguntaDoFeedback(payload)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async fetchRespostas(perguntaId?: string) {
    try {
      const request = await Apis.FeedbackAPI.FeedbackAPI.getRespostasDoFeedback(perguntaId)
      if (request.success) {
        this.setRespostas(request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
